
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic04 as ObiLogic04Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-04.js';
 
 
 

 
 export const ObiLogic04 = createComponent({
   react: React,
   tagName: 'obi-logic-04',
   elementClass: ObiLogic04Element,
   events: {
     
   }
  });
 
 